"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _store = require("../store");

var _templateObject, _templateObject2, _templateObject3;

var PageWrapper = function PageWrapper(props) {
  var sidebarActive = props.sidebarActive,
      template = props.template,
      children = props.children;

  var _ref4 = (0, _store.useStore)(),
      _ref5 = _slicedToArray(_ref4, 1),
      _ref5$0$editorState = _ref5[0].editorState,
      siteHasChanged = _ref5$0$editorState.siteHasChanged,
      postHasChanged = _ref5$0$editorState.postHasChanged;

  return /*#__PURE__*/_react.default.createElement(Container, {
    sidebar: sidebarActive
  }, template ? /*#__PURE__*/_react.default.createElement(Content, {
    disableLinks: siteHasChanged || postHasChanged
  }, children) : /*#__PURE__*/_react.default.createElement("div", {
    id: "jam-cms"
  }, children));
};

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  width: ", ";\n  margin-left: ", ";\n"])), function (_ref) {
  var sidebar = _ref.sidebar;
  return sidebar ? 'calc(100% - 320px)' : '100%';
}, function (_ref2) {
  var sidebar = _ref2.sidebar;
  return sidebar ? '320px' : 0;
});

var Content = _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n"])), function (_ref3) {
  var disableLinks = _ref3.disableLinks;
  return disableLinks && (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n      a {\n        pointer-events: none !important;\n      }\n    "])));
});

var _default = PageWrapper;
exports.default = _default;